import { hydrate } from '../../client/hydrator';

import LogIn from './log-in.page';

hydrate(LogIn, 'LogIn');
